<template>
  <img class="demo-bg" :src="bgImage" alt="" />
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div v-if="isSuccess" class="message-box _success">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
          <h2>Your booking was successful</h2>
          <h4>Booking number</h4>
          <p>
          {{ directBookingId  }}
          </p>
          <p>
            Thank you for your booking. You will receive an email and SMS with the booking details shortly within 5 minutes.
          </p>
          <div>
            <button class="success-button" @click="redirectTohomepage">BACK TO WEBSITE</button>
          </div>
        </div>
        <div v-else class="message-box _error">
          <i class="fa-solid fa-circle-xmark"></i>
          <h2>Bookings are currently closed for this facility.</h2>
          <p>
            The court lighting and bathrooms are open between 6am and 10pm, Monday to Sunday. 
          </p>
         
          <p>
            For any issues, please contact Council by calling 9725 0222 during business hours. After 5:00pm call 9725 0222 and press option 2.
          </p>
          <div>
            <button class="_error-button" @click="redirectToform">BACK TO WEBSITE</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBookingGeneral } from "../../../store/vuexStore";

export default {
  data: () => ({
    overlay: false,
    bgImage: "",
    // directBookingId: this.$route.query.bookingId || "N/A"
  }),

  methods: {
    clearOTPUserVerification() {
      // Clear all OTP user related data from sessionStorage
      sessionStorage.removeItem("onetimeToken");
      sessionStorage.removeItem("readOnlyOTP");
      sessionStorage.removeItem("otpUserBookingHours");
      sessionStorage.removeItem("email");
      
    },
    redirectTohomepage() {
      this.$router.push({ path: `/bookingapp/endeavourreserve/` });
    },
    redirectToform() {
      this.$router.push({ path: `/bookingapp/endeavourreserve/directbooking` });
    },
    setData() {
      this.data = getBookingGeneral();       // Fetching data from vuex store
      this.bgImage = this.data.homepageimage;
    },
  },
  computed: {
    isSuccess() {
      return this.$route.query.result === "1"
    },
    directBookingId() {
      return  this.$route.query.bookingId || "N/A"
    }
  },
  async created() {
    this.setData();
    this.overlay = false;
    
    // Clear OTP user verification after successful direct booking
    if (this.isSuccess) {
      this.clearOTPUserVerification();
    }
    // this.directBookingId = sessionStorage.getItem("directBookingId")
   
  },
};
</script>

<style src="./formSummaryPage.css"></style>
